import { Stack } from "@mantine/core";
import { CSSProperties } from "react";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Title } from "#components/atoms/Typographies/Title";
import { Icon, IconName } from "#shared/icons/Icon";

type OnboardingActivityCardProps = {
  icon: IconName;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
};

export const OnboardingActivityCard = ({
  icon,
  title,
  description,
  selected,
  onClick,
}: OnboardingActivityCardProps) => (
  <button type="button" aria-pressed={selected} onClick={onClick} style={cardStyle(selected)}>
    <Icon name={icon} size={96} color={colors.icon.tertiary} />
    <Stack gap={spacing[2]} align="center">
      <Title size="tiny" style={{ textAlign: "center" }}>
        {title}
      </Title>
      <Text color={colors.text.secondaryDefault} textAlign="center">
        {description}
      </Text>
    </Stack>
  </button>
);

const cardStyle = (selected: boolean): CSSProperties => ({
  flex: "1 0 0",
  minWidth: 0,
  height: 400,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: spacing[12],
  padding: `${spacing[24]} ${spacing[6]} ${spacing[12]}`,
  backgroundColor: colors.bg.elevation.primary,
  border: `2px solid ${selected ? colors.border.primaryDefault : colors.border.tertiary}`,
  borderRadius: radius.xl,
  cursor: "pointer",
});
